import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { formatPrice } from '../../helpers'
import {
  BankListModal,
  SelectBankModal,
  CommissionSummary,
  CommissionList,
  AlertModal
} from './components'

const MIN_WITHDRAWAL = 50000

const Commission = ({ history, contact }) => {
  const [loading, setLoading] = useState(true)
  const [commissions, setCommissions] = useState([])
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalData, setTotalData] = useState(0)
  const [totalFee, setTotalFee] = useState(0)

  // Bank Account State
  const [bankAccounts, setBankAccounts] = useState([])
  const [loadingBanks, setLoadingBanks] = useState(false)
  const [showBankListModal, setShowBankListModal] = useState(false)
  const [showSelectBankModal, setShowSelectBankModal] = useState(false)
  const [selectedBankId, setSelectedBankId] = useState(null)

  // Add Bank Form State
  const [showAddForm, setShowAddForm] = useState(false)
  const [bankForm, setBankForm] = useState({
    bank_name: '',
    account_holder_name: '',
    account_number: ''
  })
  const [formError, setFormError] = useState('')
  const [submittingBank, setSubmittingBank] = useState(false)
  const [submittingWithdrawal, setSubmittingWithdrawal] = useState(false)

  // Alert Modal State
  const [alertModal, setAlertModal] = useState({
    show: false,
    title: '',
    message: ''
  })

  useEffect(() => {
    fetchCommissions(page)
    fetchBankAccounts()
  }, [page])

  const fetchCommissions = (currentPage) => {
    setLoading(true)
    const token = localStorage.getItem('nabawi-token')
    fetch(`${process.env.REACT_APP_AGENT_URL}referral-history?page=${currentPage}&limit=10`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
      .then(res => res.json())
      .then(res => {
        if (res.status && res.data) {
          const list = res.data.data || []
          setCommissions(list)
          setTotalPages(res.data.pages || 1)
          setTotalData(list.length ? (res.data.pages * 10) : 0)
          const feeSum = res.data.user?.comission_balance ?? res.data.total_fee ?? res.data.totalFee ?? list.reduce((sum, item) => sum + Number(item.fee || item.amount || 0), 0)
          setTotalFee(feeSum)
        } else {
          setCommissions([])
          setTotalPages(1)
          setTotalData(0)
          setTotalFee(0)

        }
        setLoading(false)
      })
      .catch(() => {
        setCommissions([])
        setTotalPages(1)
        setTotalData(0)
        setTotalFee(0)
        setLoading(false)
      })
  }

  const fetchBankAccounts = () => {
    setLoadingBanks(true)
    const token = localStorage.getItem('nabawi-token')
    fetch(`${process.env.REACT_APP_AGENT_URL}account-bank`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
      .then(res => res.json())
      .then(res => {
        if (res.status && Array.isArray(res.data)) {
          setBankAccounts(res.data)
          if (res.data.length > 0 && !selectedBankId) {
            setSelectedBankId(res.data[0].id)
          }
        } else {
          setBankAccounts([])
        }
        setLoadingBanks(false)
      })
      .catch(() => {
        setBankAccounts([])
        setLoadingBanks(false)
      })
  }

  const handlePageHome = () => {
    history.push('/')
  }

  const canWithdraw = Number(totalFee) >= MIN_WITHDRAWAL

  const handleOpenWithdrawalModal = () => {
    if (!canWithdraw) return
    if (bankAccounts.length > 0 && !selectedBankId) {
      setSelectedBankId(bankAccounts[0].id)
    }
    setShowSelectBankModal(true)
  }

  const handleAddBankAccount = (e) => {
    e.preventDefault()
    setFormError('')

    if (!bankForm.bank_name || !bankForm.account_holder_name || !bankForm.account_number) {
      setFormError('Semua kolom harus diisi.')
      return
    }

    setSubmittingBank(true)
    const token = localStorage.getItem('nabawi-token')
    fetch(`${process.env.REACT_APP_AGENT_URL}account-bank`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(bankForm)
    })
      .then(res => res.json())
      .then(res => {
        setSubmittingBank(false)
        if (res.status) {
          setBankForm({ bank_name: '', account_holder_name: '', account_number: '' })
          setShowAddForm(false)
          if (res.data && res.data.id) {
            setSelectedBankId(res.data.id)
          }
          fetchBankAccounts()
        } else {
          setFormError(res.message || 'Gagal menambahkan rekening bank.')
        }
      })
      .catch(err => {
        setSubmittingBank(false)
        setFormError(err.message || 'Gagal menambahkan rekening bank.')
      })
  }

  const handleDeleteBankAccount = (id) => {
    if (!window.confirm('Apakah Anda yakin ingin menghapus rekening ini?')) return

    const token = localStorage.getItem('nabawi-token')
    fetch(`${process.env.REACT_APP_AGENT_URL}account-bank/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
      .then(res => res.json())
      .then(res => {
        if (res.status) {
          fetchBankAccounts()
          if (selectedBankId === id) {
            setSelectedBankId(null)
          }
        } else {
          alert(res.message || 'Gagal menghapus rekening.')
        }
      })
      .catch(err => {
        alert(err.message || 'Gagal menghapus rekening.')
      })
  }

  const handleConfirmWithdrawal = () => {
    if (!selectedBankId) {
      alert('Silakan pilih rekening bank terlebih dahulu.')
      return
    }

    const selectedBank = bankAccounts.find(b => Number(b.id) === Number(selectedBankId))
    if (!selectedBank) {
      alert('Rekening bank tidak valid.')
      return
    }

    setSubmittingWithdrawal(true)
    const token = localStorage.getItem('nabawi-token')

    fetch(`${process.env.REACT_APP_AGENT_URL}withdrawal-history`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify({
        amount: totalFee,
        account_bank_id: selectedBankId
      })
    })
      .then(res => res.json())
      .then(res => {
        setSubmittingWithdrawal(false)
        if (res.status) {
          setShowSelectBankModal(false)
          fetchCommissions(1)
          setPage(1)
          const formattedFee = formatPrice(totalFee, 'Rp.')
          const phone = contact?.payload?.phone || ''
          const text = `Halo Admin, saya ingin mengajukan penarikan komisi sebesar ${formattedFee} ke rekening ${selectedBank.bank_name} - ${selectedBank.account_number} a.n ${selectedBank.account_holder_name}`
          window.open(`https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(text)}`, '_blank')
        } else {
          setShowSelectBankModal(false)
          setAlertModal({
            show: true,
            title: 'Penarikan Gagal',
            message: res.message || 'Gagal mengajukan penarikan komisi.'
          })
        }
      })
      .catch(err => {
        setSubmittingWithdrawal(false)
        setShowSelectBankModal(false)
        setAlertModal({
          show: true,
          title: 'Penarikan Gagal',
          message: err.message || 'Terjadi kesalahan saat mengajukan penarikan komisi.'
        })
      })
  }

  return (
    <>
      <div className="breadcrumb-halaman">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a
                onClick={handlePageHome}
                className="clickable"
              >Beranda</a>
            </li>
            <li className="breadcrumb-item active">Riwayat komisi</li>
          </ol>
        </nav>
      </div>

      <div className="container">
        <div className="cover-keranjang-all">
          <div className="cover-isi">
            <CommissionList
              loading={loading}
              commissions={commissions}
              page={page}
              totalPages={totalPages}
              setPage={setPage}
            />

            <CommissionSummary
              totalFee={totalFee}
              canWithdraw={canWithdraw}
              handleOpenWithdrawalModal={handleOpenWithdrawalModal}
              setShowBankListModal={setShowBankListModal}
            />
          </div>
        </div>
      </div>

      <BankListModal
        show={showBankListModal}
        onHide={() => setShowBankListModal(false)}
        loadingBanks={loadingBanks}
        bankAccounts={bankAccounts}
        showAddForm={showAddForm}
        setShowAddForm={setShowAddForm}
        bankForm={bankForm}
        setBankForm={setBankForm}
        formError={formError}
        setFormError={setFormError}
        submittingBank={submittingBank}
        handleAddBankAccount={handleAddBankAccount}
        handleDeleteBankAccount={handleDeleteBankAccount}
      />

      <SelectBankModal
        show={showSelectBankModal}
        onHide={() => setShowSelectBankModal(false)}
        totalFee={totalFee}
        loadingBanks={loadingBanks}
        bankAccounts={bankAccounts}
        selectedBankId={selectedBankId}
        setSelectedBankId={setSelectedBankId}
        submittingWithdrawal={submittingWithdrawal}
        handleConfirmWithdrawal={handleConfirmWithdrawal}
        onOpenAddBank={() => {
          setShowSelectBankModal(false)
          setShowBankListModal(true)
          setShowAddForm(true)
        }}
      />

      <AlertModal
        show={alertModal.show}
        onHide={() => setAlertModal({ show: false, title: '', message: '' })}
        title={alertModal.title}
        message={alertModal.message}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    contact: {
      payload: state.util?.contact?.payload
    }
  }
}

export default compose(withRouter, connect(mapStateToProps))(Commission)
